export const GET_TRANSACTION_PROVISION_SETTLE_LIST = "GET_TRANSACTION_PROVISION_SETTLE_LIST"
export const GET_TRANSACTION_PROVISION_SETTLE_LIST_SUCCESS = "GET_TRANSACTION_PROVISION_SETTLE_LIST_SUCCESS"
export const GET_TRANSACTION_PROVISION_SETTLE_LIST_FAIL = "GET_TRANSACTION_PROVISION_SETTLE_LIST_FAIL"

export const GET_TRANSACTION_PROVISION_SETTLE_SEARCH = "GET_TRANSACTION_PROVISION_SETTLE_SEARCH"
export const GET_TRANSACTION_PROVISION_SETTLE_SEARCH_SUCCESS = "GET_TRANSACTION_PROVISION_SETTLE_SEARCH_SUCCESS"
export const GET_TRANSACTION_PROVISION_SETTLE_SEARCH_FAIL = "GET_TRANSACTION_PROVISION_SETTLE_SEARCH_FAIL"

export const TRANSACTION_PROVISION_SETTLE_API_ERROR = "TRANSACTION_PROVISION_SETTLE_API_ERROR"